"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../../index");
var Messages = require("../../codegen/Messages");
/**
 * OUI information dialog component.
 *
 * @oui-component InformationDialog
 */
var InformationDialog = function (props) {
    var handleClose = React.useCallback(function () {
        if (props.closeDisabled) {
            return;
        }
        props.closeHandler && props.closeHandler();
    }, [props.closeDisabled, props.closeHandler]);
    var footer = (React.createElement("div", null,
        React.createElement(index_1.Button, { buttonStyle: index_1.ButtonStyle.Primary, onClick: handleClose }, props.closeText || Messages.Common.close())));
    return (React.createElement(index_1.Modal, __assign({}, props, { footerContent: footer }), props.children));
};
exports.default = InformationDialog;
//# sourceMappingURL=InformationDialog.js.map